import React, { useState, useEffect, useRef } from "react";
import { Stepper, Step } from "react-form-stepper";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit";
import { TextField } from "@material-ui/core";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
//Boostrap
import { Card, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
// import Divider from "@material-ui/core/Divider";
//table
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import campagnEmailService from "./../../../../services/MarketingService/CampagnEmailService"
import clientService from "./../../../../services/MarketingService/ClientService"
import { Swal } from 'sweetalert2';
import { EmailEditor } from 'react-email-editor';
//pagination
import paginationFactory from "react-bootstrap-table2-paginator";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const stepTitle = ["Creation", "Template", "Destinataires", "Date de l'envoi"];

function AddCampagneE() {
  const [nouvelleCampagneEmail, setNouvelleCampagneEmail] = useState({});

  const [clientIds, setClientIds] = useState([]); // pour recuperer les clients selectionnee
  const [clients, setClients] = useState([]); // pour recuperer les clients
  //const [selectAll, setSelectAll] = useState(false);
  const [selectedClients, setSelectedClients] = useState({});
  const [nbLignes, setNbLignes] = useState(2);
  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [selectedClientCount, setSelectedClientCount] = useState(0); // Nouvelle variable
  const [selectAll, setSelectAll] = useState(false);
  const [PiecesJoints, setPiecesJoints] = useState("");
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [designstate, setDesignstate] = useState(null); //templateeditor
  const [htmlstate, setHtmlstate] = useState(null); //templateeditor
  const emailEditorRef = useRef(null);
  const onLoad = () => {
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.loadDesign(designstate);
      //console.log(designstate)
    }
  };

  // filter date debut
  const onChangeStartDate = (event) => {
    setNouvelleCampagneEmail({
      ...nouvelleCampagneEmail,
      debutDate: event.target.value,
    });
  };

  // methode pour sweetAlert : pour afficher le success de la modification de publication
  const handleSuccess = () => {
    Swal.fire({
      icon: "success",
      html: `<strong>${success}</strong>`,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  //useEffect
  useEffect(() => {
    // if (success) {
    //   handleSuccess();
    // }
    AfficherListClients();
  }, []);

  const AfficherListClients = () => {
    try {
      clientService.AfficherListClients(getCurrentUserId()).then((response) => {
        setClients(response.data.success);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNouvelleCampagneEmail({ ...nouvelleCampagneEmail, [name]: value });
  };

  //methode select checkbox table

  //methode select All client

  //methode d'ajout
  const ajouterCampagneEmail = async (event) => {
    event.preventDefault();

    try {
      campagnEmailService.ajouterCampagneEmail(
        nouvelleCampagneEmail,
        clientIds,
        attachment,
        piecesJointesdata
      ).then((response) => {
        console.log(response.data); // Afficher la réponse
        //console.log(nouvelleCampagneEmail);
        // Réinitialiser les champs
        // setNouvelleCampagneEmail("");
        // setHtmlstate("");
        // setDesignstate("");
        // setSelectedClients("");
        // setClientIds([]);
        // setPiecesJointesdata([]);
        // setSuccess("Ajout validé avec succès !");
        // handleSuccess();
        console.log(response.data.success); // Afficher la réponse
        // Réinitialiser les champs
        toastr.success("Ajout validée avec success !! ")

        // setSuccess("Ajout validée avec success !! ");
        setTimeout(() => {
          navigate(`/Campagne/PageCampagneE`);
        }, 2000);
      }).catch((error) => {
        toastr.error("Erreur lors de l'insertion." + error)

      })

    } catch (error) {
      console.log(error); // Afficher l'erreur
      // console.log("erreur");
      // console.log(nouvelleCampagneEmail);
    }
  };

  //pagination
  const options = {
    sizePerPage: 7,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  // route
  const navigate = useNavigate();

  //Stepper
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.exportHtml((data) => {
        const { design, html } = data;
        setDesignstate(design);
        setHtmlstate(html);
        setActiveStep(Math.min(activeStep + 1, 3));
      });
    } else {
      setActiveStep(Math.min(activeStep + 1, 3));
    }
    setNouvelleCampagneEmail({
      ...nouvelleCampagneEmail,
      templateJson: JSON.stringify(designstate),
      templatehtml: htmlstate,
    });
  };
  const handleNextStepToFinal = () => {
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.exportHtml((data) => {
        const { design, html } = data;
        setDesignstate(design);
        setHtmlstate(html);
        if (activeStep === 0) {
          setActiveStep(1);
        } else if (activeStep === 1) {
          setActiveStep(3);
        }
      });
    } else {
      if (activeStep === 0) {
        setActiveStep(1);
      } else if (activeStep === 1) {
        setActiveStep(3);
      }
    }
    setNouvelleCampagneEmail({
      ...nouvelleCampagneEmail,
      templateJson: JSON.stringify(designstate),
      templatehtml: htmlstate,
    });
  };

  const handleBackStep = () => {
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.exportHtml((data) => {
        const { design, html } = data;
        setDesignstate(design);
        setHtmlstate(html);
        setActiveStep(Math.max(activeStep - 1, 0));
      });
    } else {
      setActiveStep(Math.max(activeStep - 1, 0));
    }
    setNouvelleCampagneEmail({
      ...nouvelleCampagneEmail,
      templateJson: JSON.stringify(designstate),
      templatehtml: htmlstate,
    });
  };
  const handleBackStepToStart = () => {
    if (emailEditorRef.current && emailEditorRef.current.editor) {
      emailEditorRef.current.editor.exportHtml((data) => {
        const { design, html } = data;
        setDesignstate(design);
        setHtmlstate(html);
        setActiveStep(Math.max(activeStep - 2, 0));
      });
    } else {
      setActiveStep(Math.max(activeStep - 2, 0));
    }
    setNouvelleCampagneEmail({
      ...nouvelleCampagneEmail,
      templateJson: JSON.stringify(designstate),
      templatehtml: htmlstate,
    });
  };

  const stepStyleConfig = {
    activeBgColor: "#848687",
    completedBgColor: "#333",
  };

  //condition sur radio button pour importer fichier de numero de clients
  const [isImporting, setIsImporting] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleRadioChange = (event) => {
    if (event.target.value === "importer") {
      setIsImporting(true);
    } else {
      setIsImporting(false);
    }
  };
  const [fileName, setFileName] = useState("");

  const handleAttachmentChange = (event) => {
    setAttachment(event.target.files[0]);
    setFileName(event.target.files[0].name);
    setNbLignes(null);
  };

  const handleCompterLignes = () => {
    if (attachment) {
      const reader = new FileReader();
      reader.onload = () => {
        const lines = reader.result.split("\n");
        setNbLignes(lines.length);
      };
      reader.readAsText(attachment);
    }
  };

  useEffect(() => {
    handleCompterLignes();
  }, [attachment]);

  // Method to handle select all checkbox change
  const handleSelectAllCheckboxChange = (isSelect) => {
    const newSelectedClients = {};
    const newClientIds = [];

    clients.forEach((client) => {
      newSelectedClients[client.id] = isSelect;
      if (isSelect) {
        newClientIds.push(client.id);
      }
    });

    let updatedSelectAll = false;
    if (isSelect && newClientIds.length === clients.length) {
      updatedSelectAll = true;
    }

    setSelectedClients(newSelectedClients);
    setClientIds(newClientIds);
    setSelectAll(updatedSelectAll);
  };

  const handleCheckboxChange = (row, isSelect) => {
    const clientId = row.id;
    const newSelectedClients = { ...selectedClients };
    newSelectedClients[clientId] = isSelect;

    let newClientIds;
    if (isSelect) {
      // If the checkbox was checked, add the current client ID to the selected client IDs
      newClientIds = [...clientIds, clientId];
    } else {
      // If the checkbox was unchecked, remove the current client ID from the selected client IDs
      newClientIds = clientIds.filter((id) => id !== clientId);
    }

    setSelectedClients(newSelectedClients);
    setClientIds(newClientIds);
  };
  //pieces joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);

    // Reset the file input field
    //document.getElementById("pieces-jointes").value = null;
  };
  const columns = [
    { dataField: "lastName", text: "Nom" },
    { dataField: "firstName", text: "Prénom" },
    { dataField: "phoneNumber", text: "Numero" },
    { dataField: "age", text: "Age" },
    { dataField: "rue", text: "Rue" },
    { dataField: "ville", text: "Ville" },
    { dataField: "pays", text: "Pays" },
  ];
  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne Email</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne/PageCampagneE">Email</a>
                </li>
                <li className="breadcrumb-item active">Creation</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}


      {/* content */}
      <section className="content mt-3">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Ajouter Campagne d'email</h3>
            </div>
            <div className="card-body">
              <Stepper styleConfig={stepStyleConfig} activeStep={activeStep}>
                {stepTitle.map((title) => (
                  <Step key={title} label={title} />
                ))}
              </Stepper>
              {activeStep === 0 ? (
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label>Nom</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Nom"
                        name="nom"
                        onChange={handleChange}
                        value={nouvelleCampagneEmail.nom || ""}
                      />
                    </div>
                    <div className="form-group">
                      <label>Objectif</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Objectif ..."
                      />
                    </div>
                    <div className="form-group">
                      <label>Objet d'email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Objet d'email"
                        name="objetEmail"
                        onChange={handleChange}
                        value={nouvelleCampagneEmail.objetEmail || ""}
                      />
                    </div>
                    <div className="form-group">
                      <label> Contenu d'email</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Contenu Email ..."
                        name="contenu"
                        onChange={handleChange}
                        value={nouvelleCampagneEmail.contenu || ""}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="pieces-jointes">Pieces jointes</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="pieces-jointes"
                            name="pieces-jointes"
                            value={PiecesJoints}
                            onChange={handlePieceJointeChange}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="pieces-jointes"
                          >
                            {piecesJointesdata.length === 0
                              ? "Choose file"
                              : piecesJointesdata
                                .map((fichier) => fichier.name)
                                .join(", ")}
                          </label>
                        </div>
                        {piecesJointesdata.length > 0 && (
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleDeletePieceJointe}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        )}
                      </div>
                      {/* affichage des images  */}
                      <div className="row mt-3">
                        {piecesJointesdata.map((fichier, index) => (
                          <div
                            key={index}
                            className="col-sm-3 text-center mb-3"
                          >
                            <img
                              src={URL.createObjectURL(fichier)}
                              alt={fichier.name}
                              style={{ width: "100%", height: "80%" }}
                            />
                            <button
                              className="btn btn-outline-danger col-sm mt-3 mb-3"
                              type="button"
                              onClick={() => handleDeletePieceJointe(index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                      {/* end of affichage des images  */}
                    </div>

                    <div className="form-group">
                      <label> Destinataires</label>
                      <div className="custom-control custom-radio">
                        <input
                          className="custom-control-input custom-control-input-dark"
                          type="radio"
                          id="customRadio1"
                          name="customRadio"
                          value="liste"
                          checked={!isImporting}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="customRadio1"
                          className="custom-control-label"
                        >
                          Liste
                        </label>
                      </div>
                      <div className="custom-control custom-radio">
                        <input
                          className="custom-control-input custom-control-input-dark"
                          type="radio"
                          id="customRadio2"
                          name="customRadio"
                          value="importer"
                          checked={isImporting}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="customRadio2"
                          className="custom-control-label"
                        >
                          Importer fichier
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      {isImporting && (
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                              onChange={handleAttachmentChange}
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="exampleInputFile"
                            >
                              {fileName || "Importer fichier CSV"}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              {activeStep === 1 ? (
                <div>
                  <EmailEditor ref={emailEditorRef} onLoad={onLoad} />
                </div>
              ) : null}
              {activeStep === 2 ? (
                <Card className="Campagne-card-buttons">
                  <Card.Body>
                    <div className="row">
                      <div className="col">
                        <Card
                          style={{
                            backgroundColor: "#848687",
                            color: "white",
                          }}
                        >
                          <Card.Body>
                            <div className="row">
                              <div className="col-3 text-center">
                                <label className="col">
                                  Nombre de Destinataires
                                </label>
                                <label className="col">
                                  {clientIds.length}
                                </label>
                              </div>
                              <div className="col-8">
                                <label className="col">Filtres</label>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="w-100"></div>
                      <div className="col">
                        <div className="table-container thead-dark mb-3">
                          <BootstrapTable
                            keyField="id"
                            data={clients}
                            columns={columns}
                            selectRow={{
                              mode: "checkbox",
                              clickToSelect: true,
                              selected: clientIds,
                              onSelect: handleCheckboxChange,
                              onSelectAll: handleSelectAllCheckboxChange,
                            }}
                            bordered={false}
                            hover
                            condensed
                            pagination={paginationFactory(options)}
                            defaultSorted={[
                              {
                                dataField: "createdDate",
                                order: "asc",
                              },
                            ]}
                            faultSortDirection="asc"
                            noDataIndication={() => "No data found"}
                            headerClasses="thead-dark"
                          />
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ) : null}
              {activeStep === 3 ? (
                <>
                  <Card className="Campagne-card-buttons">
                    <Card.Body>
                      <div className="row">
                        <div className="col">
                          <Card
                            style={{
                              backgroundColor: "#848687",
                            }}
                          >
                            <Card.Body>
                              <div className="row">
                                <div className="col-3 text-center">
                                  <label className="col">Type</label>
                                  <label className="col">Email</label>
                                </div>
                                <div className="col-3 text-center">
                                  <label className="col">
                                    Destinataires
                                  </label>
                                  <label className="col">
                                    {isImporting
                                      ? nbLignes - 2
                                      : clientIds.length}
                                  </label>
                                </div>

                                <div className="col-3 text-center">
                                  <label htmlFor="startDate">
                                    Date de l'envoi{" "}
                                  </label>
                                  <div className="col-3 text-center">
                                    <label className="col">
                                      <TextField
                                        variant="outlined"
                                        value={
                                          nouvelleCampagneEmail.debutDate
                                        }
                                        onChange={onChangeStartDate}
                                        name="debutDate"
                                        id="datetime-local"
                                        type="datetime-local"
                                        defaultValue="date"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        size="small"
                                      // className="mt-2"
                                      //style={{ backgroundColor: "white"}}
                                      />
                                    </label>
                                  </div>
                                </div>

                                <div className="col-3 text-center">
                                  <label className="col">Cout</label>
                                  <label className="col">
                                    {clientIds.length * 100}
                                  </label>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="w-100"></div>

                        <div className="col">
                          <Card>
                            <Card.Body>
                              <div className="row">
                                <h5 className="col-12 text-center font-weight">
                                  Aperçu de l'Email envoyé aux
                                  <span> {clientIds.length} </span>
                                  destinataires
                                </h5>
                                <div className="col-12 text-center text-muted">
                                  <small>
                                    Cet aperçu est affiché à titre
                                    indicatif, le résultat final peut être
                                    différent
                                  </small>
                                </div>

                                <div className="container mt-3">
                                  <div className="row">
                                    <div className="col">
                                      <label>Contenu :</label>
                                    </div>
                                    <div className="w-100"></div>

                                    <div className="col">
                                      <div>
                                        {nouvelleCampagneEmail.contenu && (
                                          <div>
                                            {nouvelleCampagneEmail.contenu}
                                          </div>
                                        )}
                                        {nouvelleCampagneEmail.contenu &&
                                          htmlstate && (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: htmlstate,
                                              }}
                                            ></div>
                                          )}
                                        {!nouvelleCampagneEmail.contenu &&
                                          htmlstate && (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: htmlstate,
                                              }}
                                            ></div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row  mt-3">
                                    <div className="col">
                                      <label>Contact :</label>
                                    </div>
                                    <div className="w-100"></div>

                                    <div className="col">
                                      {
                                        nouvelleCampagneEmail.informationSociete
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  {/* /.table */}
                </>
              ) : null}
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col">
                  {/* condition sur lsuivant et precedent */}
                  <FaChevronLeft
                    onClick={
                      isImporting ? handleBackStepToStart : handleBackStep
                    }
                  />
                  <FaChevronRight
                    onClick={
                      isImporting ? handleNextStepToFinal : handleNextStep
                    }
                  />
                </div>

                {/* condition sur les button Ajouter + annuler */}
                <div className="col text-right" style={{ width: "100%" }}>
                  <Button
                    className="btn btn-secondary mr-2"
                    onClick={() => navigate("/Campagne/PageCampagneE")}
                    style={{ width: "150px" }}
                  >
                    Annuler
                  </Button>
                  <Button
                    className="btn btn-dark"
                    disabled={activeStep !== 3}
                    style={{ width: "150px" }}
                    onClick={ajouterCampagneEmail}
                  >
                    Ajouter
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
    </div>
  );
}

export default AddCampagneE;
